module.exports = __webpack_public_path__ + "img/pic10.0bf9e64f.jpg";